import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.css"],
})
export class ChangePasswordComponent implements OnInit {
  myForm!: UntypedFormGroup;
  isLoader: boolean = false;
  fieldTextType: boolean | undefined;
  ROLEID: any;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private route: Router,
    private CommonService: CommonService
  ) { }

  async ngOnInit() {

    // ✅ Create form FIRST
    this.myForm = this.formBuilder.group({
      password: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/
          )
        ]
      ],
      confirmPassword: ["", Validators.required],
    });

    // ✅ Then do async work
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      localStorage.getItem("RoleId"),
      this.CommonService.key
    );

    this.ROLEID = +decryptedValue;
  }

  checkPassword(): boolean {
    const passwordInput = document.getElementById(
      "password"
    ) as HTMLInputElement;
    const value = passwordInput?.value || "";

    const letter = document.getElementById("letter");
    const capital = document.getElementById("capital");
    const number = document.getElementById("number");
    const length = document.getElementById("length");
    const special = document.getElementById("specialCharacter");

    const validations = {
      hasLower: /[a-z]/.test(value),
      hasUpper: /[A-Z]/.test(value),
      hasNumber: /[0-9]/.test(value),
      hasSpecial: /[!"`'#%&,:;<>=@{}~\$\(\)\*\+\/\\\?\[\]\^\|]+/.test(value),
      hasMinLength: value.length >= 8,
    };

    // Update DOM indicators
    letter?.classList.toggle("valid", validations.hasLower);
    letter?.classList.toggle("invalid", !validations.hasLower);

    capital?.classList.toggle("valid", validations.hasUpper);
    capital?.classList.toggle("invalid", !validations.hasUpper);

    number?.classList.toggle("valid", validations.hasNumber);
    number?.classList.toggle("invalid", !validations.hasNumber);

    special?.classList.toggle("valid", validations.hasSpecial);
    special?.classList.toggle("invalid", !validations.hasSpecial);

    length?.classList.toggle("valid", validations.hasMinLength);
    length?.classList.toggle("invalid", !validations.hasMinLength);

    // Return true if ALL validations pass
    return Object.values(validations).every((v) => v === true);
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  passwordValidator() {
    return Validators.pattern(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
    );
  }
  submit(form: UntypedFormGroup) {
    this.isLoader = true;
    if (!this.checkPassword()) {
      this.toastr.warning("Please check the password format.");
      this.isLoader = false;
      return;
    }
    let value = form.value;
    let payload = {
      userid: localStorage.getItem("UserId"),
      password: value.password,
    };
    var password: any = (<HTMLInputElement>document.getElementById("password"))
      ?.value;
    var confirmPassword: any = (<HTMLInputElement>(
      document.getElementById("confirmPassword")
    ))?.value;
    if (password != confirmPassword) {
      this.toastr.warning("Passwords do not match.");
      return (this.isLoader = false);
    } else {
      if (value.password == "") {
        this.toastr.error("Password is required");
        return (this.isLoader = false);
      }

      this.CommonService.postCall(
        `Registration/UpdateUserPassWord`,
        payload
      ).subscribe(
        (res: any) => {
          this.toastr.success("Password Changed Successfully");
          this.isLoader = false;
          this.Signout();
        },
        (err) => {
          this.toastr.error(err.error ? err.error : "Password Not Changed");
          this.isLoader = false;
        }
      );
    }
  }

  Signout() {
    this.clearToken();
    setTimeout(() => {
      localStorage.clear();
      sessionStorage.clear();
      if (this.ROLEID == "2115" || this.ROLEID == "2116")
        this.route.navigate(["/vendorlogin"]);
      else this.route.navigate(["/login"]);
    }, 500);
  }
  clearToken() {
    this.CommonService.postCall("Account/ClearToken", {
      UserID: localStorage.getItem("UserId"),
    }).subscribe((res: any) => { });
  }
}
